import AppTextField from '@/components/AppTextField';
import SendCodeButton from '@/components/SendCodeButton';
import AppLoadingButton from '@/components/mui/LoadingButton';
import API from '@/constant/API';
import RouteConstant from '@/constant/RouteConstant';
import classes from "@/pages/login/components/css/index.module.less";
import { getUserInfo, setToken } from '@/redux/slices/user';
import { dispatch } from '@/redux/store';
import { signInGoogle } from '@/utils/auth';
import axiosInstance from '@/utils/axios';
import { getUrlParams ,isJSONStr} from '@/utils/utils';
import {Box, Divider, InputAdornment, Link, Stack, CircularProgress, useTheme, circularProgressClasses,
  buttonClasses
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { fbLogEventDefaultParams, FB_EVENT_TYPES } from '@/utils/firebase';

const PAGE_NAME = 'register';
export default function InviteRegisterForm({ accessToken, onAccessTokenUsed, setIsLogin, interceptAction }) {
  const utmId = useRef();
  const utmSource = useRef();
  const utmS = useRef();
  const utmUid = useRef();

  useEffect(() => {
    // check referralId in url params.
    let referralId = getUrlParams('referralId');
    utmId.current = getUrlParams("utm_id")
    utmSource.current = getUrlParams("utm_source")
    utmUid.current = getUrlParams("utm_uid")
    utmS.current = getUrlParams("utm_s")

    if (referralId != null) {
      const index = referralId.indexOf(" ");
      if (index > -1) {
        referralId = referralId.substring(0, index)
      }
      setReferralId(referralId);
    }
  }, []);

  useEffect(() => {
    if (accessToken) {
      submit3rdAuth(accessToken);
      onAccessTokenUsed?.();
    }
  }, [accessToken]);

  const sendCodeBtnRef = useRef(null);
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [referralId, setReferralId] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const theme = useTheme()

  const [usernameError, setUsernameError] = useState(null);
  const [codeError, setCodeError] = useState(null);

  const [sendCodeEnable, setSendCodeEnable] = useState(false);

  const { t } = useTranslation();

  const [googleLogining, setGoogleLogining] = useState(false);

  const onLoginCallback = (res) => {
    if (isJSONStr(res.data )) {
      res.data = JSON.parse(res.data)
    }
    setToken(res?.data?.data.tokenValue);
    if (res?.se && res?.sa) {
      const algInfo = {
        se: res.se,
        sa: res.sa
      }
      localStorage.setItem('algInfo', JSON.stringify(algInfo))
    }
  }
  // 通过三方accessToken
  const submit3rdAuth = async (accessToken3rd, error?) => {
    setGoogleLogining(false)
    if (!accessToken3rd) return;

    setUsernameError(false);
    setCodeError(false);
    try {
      setLoading(true);
      const params = {
        username: accessToken3rd,
        shareId: referralId,
        // bindChannel: 'google',
        utm_id:utmId.current,
        utm_source: utmSource.current,
        utm_s:utmS.current,
        utm_uid:utmUid.current,

        'providerId': 'google.com',
        'thirdToken': accessToken3rd,
      };
      const res = await axiosInstance.post(API.LOGIN_3RD_AUTH_V2, params); //  INVITE_BIND LOGIN_3RD_AUTH
      onLoginCallback(res);

      // _onRegisterComplete();
      fbLogEventDefaultParams(FB_EVENT_TYPES.REGISTER_WITH_GOOGLE_SUCCESS,{ pageName:PAGE_NAME })
      _onSubmitHandlerSuccess()
    } catch(error) {
    } finally {
      setLoading(false);
    }
  };


  const handleRegisterClick = () => {
    fbLogEventDefaultParams(FB_EVENT_TYPES.REGISTER_CLICK, { pageName: PAGE_NAME });
    interceptAction?.();
  };

  const _onSubmitHandlerSuccess = () => {
    navigate(RouteConstant.MAIN, {
      replace: true
    });
  }

  const _onRegisterComplete = () => {
    navigate(RouteConstant.MAIN, {
      replace: true
    });
  }

  const onUsernameChange = function(e) {
    const username = e.target.value?.trim() || '';
    setUsername(username);

    checkSendCodeEnable(username);
  };
  const checkSendCodeEnable = function(username) {
    setSendCodeEnable(username.length >= 3 && username.indexOf('@') !== -1);
  };

  const _signInGoogle = () => {
    setGoogleLogining(true);
    fbLogEventDefaultParams(FB_EVENT_TYPES.REGISTER_WITH_GOOGLE_CLICK,{ pageName:PAGE_NAME })
    signInGoogle(submit3rdAuth);
  }

  return (
    <form autoComplete="off" onSubmit={(evt) => evt.preventDefault()}>
      <Box className={classes["login-box"]}>
        <AppTextField
          label={t("email")}
          placeholder={t('email')}
          onChange={onUsernameChange}
          required
          value={username}
          error={usernameError}
          fullWidth
          autoFocus={false}
          onFocus={()=>fbLogEventDefaultParams(FB_EVENT_TYPES.USERNAME_INPUT,{ pageName:PAGE_NAME })}
        />
        <AppTextField
          label={t("verify_code")}
          placeholder={t('verify_code')}
          onChange={(e) => setCode(e.target.value)}
          required
          value={code}
          error={codeError}
          fullWidth
          autoFocus={false}
          onFocus={()=>fbLogEventDefaultParams(FB_EVENT_TYPES.CODE_INPUT,{ pageName:PAGE_NAME })}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SendCodeButton
                  // style={{ color: "#E43664" }}
                  ref={sendCodeBtnRef}
                  enable={sendCodeEnable}
                  btnText={t('get_code')}
                  action='register'
                  useRecaptcha={true}
                  pageName={PAGE_NAME}
                  params={
                    { email: username }
                  }
                  onError={(error)=>{}}
                />
              </InputAdornment>
            ),
          }}
        />
        <Box>
          <AppLoadingButton
            fullWidth
            loading={loading}
            variant="contained"
            color="primary"
            size="large"
            type="button"
            onClick={handleRegisterClick}
          >
            {t('register')}
          </AppLoadingButton>
          <Box className={classes["terms-policy"]}>
            <p>
              {t("by_creating_an_account")}
              <Link color="error" className="link" rel="noreferrer" href="https://www.redotpay.com/en/terms/">
                {` ${t("terms_conditions")} `}
              </Link>
              {/*{t("and")}*/}
              {/*<Link color="error" className="link" href="#">*/}
              {/*  {` ${t("privacy_policy")} `}*/}
              {/*</Link>*/}
            </p>
          </Box>
        </Box>
        <Stack direction={'row'} sx={{ fontSize: 14}} spacing={1} alignItems={'center'} justifyContent={'center'}>
          <div>{t('already_have_an_account')}</div>
          <Link color="error" style={{cursor:"pointer"}} onClick={() => {
            fbLogEventDefaultParams(FB_EVENT_TYPES.LOGIN_CLICK,{ pageName:PAGE_NAME })
            setIsLogin(true)
          }}>{t('login')}</Link>
        </Stack>
      </Box>
      {/* <Box className={'fixed-button'}>
        <Stack direction={'column'} gap={'24px'}>
          <Divider sx={{fontSize:'12px',fontWeight:400}}>{t('or_continue_with')}</Divider>
          <LoadingButton loading={googleLogining}
                         loadingPosition="end"
                         loadingIndicator={<CircularProgress size={16} />}
           sx={{
             border: `1px solid ${'rgba(16, 5, 28, 0.10)'}`,
             padding: '12px 0',
             [`& .MuiLoadingButton-loadingIndicator`]: {
               right: '70px !important'
             },
              [`& .${circularProgressClasses.root}`]: {
                color: theme.palette.brand.main,
              }
           }}
            direction="row" justifyContent="center" alignItems="center" className={classes["login-other-channel"]} onClick={_signInGoogle}>
            <Stack gap='12px' direction="row" justifyContent="center" alignItems="center">
              <img src="/images/google.png" />
              <div className="h4">{t('continue_with_google')}</div>
            </Stack>
          </LoadingButton>
        </Stack>
      </Box> */}
    </form>
  );
}
